export default class TimeSpan {
  constructor(public start: number, public end: number) {
  }
}
